import React, { useEffect, useState } from "react";
import {
    gtetHiringPartners,
    AddHiringPartners,
    deleteHiringPartners,
} from "Services/allApi"; // Replace with actual API paths
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from "react-icons/md";

function HiringPartners() {
    const [hiringPartners, setHiringPartners] = useState([]); // Ensure the initial state is an array
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [uploading, setUploading] = useState(false);

    // Fetch hiring partners on mount
    useEffect(() => {
        const fetchHiringPartners = async () => {
            try {
                const response = await gtetHiringPartners();
                // Ensure response.data is an array
                if (Array.isArray(response.data)) {
                    setHiringPartners(response.data);
                } else {
                    throw new Error("Invalid data format from API");
                }
            } catch (err) {
                setError(err.message || "Failed to load hiring partners.");
            } finally {
                setLoading(false);
            }
        };

        fetchHiringPartners();
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const resetModalState = () => {
        setImage(null);
        setImagePreview("");
        setUploading(false);
        setIsModalOpen(false);
    };

    const handleAddHiringPartner = async () => {
        if (!image) {
            toast.error("Please select an image first.");
            return;
        }

        setUploading(true);
        const formData = new FormData();
        formData.append("image", image);

        try {
            const response = await AddHiringPartners(formData);
            setHiringPartners((prev) => [...prev, response.data]);
            resetModalState();
            toast.success("New hiring partner added successfully!");
        } catch (error) {
            toast.error("Failed to add hiring partner. Please try again.");
        } finally {
            setUploading(false);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this hiring partner?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            customClass: {
                popup: 'dark:bg-gray-800 dark:text-white', // Dark background and white text
                title: 'dark:text-white',
                confirmButton: 'dark:bg-blue-500 dark:hover:bg-blue-700 dark:text-white',
                cancelButton: 'dark:bg-red-500 dark:hover:bg-red-700 dark:text-white'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteHiringPartners(id);
                    setHiringPartners((prev) => prev.filter((partner) => partner.id !== id));
                    Swal.fire("Deleted!", "The hiring partner has been deleted.", "success");
                } catch (error) {
                    Swal.fire("Error!", "Failed to delete hiring partner. Please try again.", "error");
                }
            }
        });
    };

    return (
        <div className="max-w-8xl mx-auto p-6 bg-gray-50 min-h-screen mt-5 dark:bg-[#0b14374d] dark:text-white">
            <div className="mb-4 flex justify-end mt-3 mb-5">
                <button
                    onClick={() => {
                        resetModalState();
                        setIsModalOpen(true);
                    }}
                    className="bg-purple-800 text-white px-4 py-2 rounded-lg font-medium text-sm hover:bg-purple-700"
                >
                    Add Hiring Partner
                </button>
            </div>

            <div className="bg-white shadow-lg rounded-lg overflow-hidden dark:bg-[#0b14374d] dark:text-white">
                {loading ? (
                    <div className="text-center text-purple-800 py-4">
                        Loading hiring partners...
                    </div>
                ) : error ? (
                    <div className="text-center text-red-600 py-4">{error}</div>
                ) : hiringPartners.length === 0 ? (
                    <div className="text-center text-purple-800 py-4">
                        No hiring partners available.
                    </div>
                ) : (
                    <table className="table-auto w-full text-left">
                        <thead className="text-center ">
                            <tr className="bg-gray-100 dark:bg-gray-800 dark:text-white">
                                <th className="px-4 py-2">ID</th>
                                <th className="px-4 py-2">Hiring Partner</th>
                                <th className="px-4 py-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {hiringPartners.map((partner,index) => (
                                <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                                    <td className="px-4 py-2">{index+1}</td>
                                    <td className="px-4 py-2 d-flex justify-items-center">

                                        <img
                                            src={partner.image}
                                            alt="Hiring Partner"
                                            style={{ objectFit: "contain" }}
                                            className="h-20 w-32 rounded-lg "
                                        />
                                      </td>
                                    <td className="px-4 py-2">
                                        <button
                                            onClick={() => handleDelete(partner.id)}
                                        >
                                            <MdDelete className="text-xl" style={{ color: "red" }} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg max-w-lg w-full dark:!bg-navy-700 dark:text-white">
                        <h2 className="text-lg font-semibold mb-4">Add Hiring Partner</h2>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{objectFit:"contain"}}
                            class="block w-full mb-5 text-xs text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400" id="small_size"  />
                        {imagePreview && (
                            <div className="mt-4 d-flex">
                                <img
                                    src={imagePreview}
                                    alt="Selected"
                                    className="h-32 w-32 object-cover rounded-lg"
                                />
                            </div>
                        )}
                        <div className="mt-4 flex justify-end">
                            <button
                                onClick={() => setIsModalOpen(false)}
                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg mr-2 hover:bg-gray-400"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleAddHiringPartner}
                                disabled={uploading}
                                className="bg-purple-800 text-white px-4 py-2 rounded-lg hover:bg-purple-700"
                            >
                                {uploading ? "Uploading..." : "Add"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} />
        </div>
    );
}

export default HiringPartners;
